export const CampaignTypes = {
  GENERAL: "GENERAL",
  GAME_AT_THE_BEGINNING: "GAME_AT_THE_BEGINNING",
  GAME_AT_THE_END: "GAME_AT_THE_END",
  PREDICTION: "PREDICTION",
  LOYALTY: "LOYALTY",
};
